import {BehaviorSubject} from 'rxjs';

import UiEventType            from '../../Ui/Shared/Constants/UiEventType';
import IUiEventsStreamPayload from '../../Ui/Shared/Interfaces/IUiEventsStreamPayload';
import IEventBinding          from '../Interfaces/IEventBinding';
import Player                 from '../Player';

const bindRootBlurEvent = (player: Player): IEventBinding => {
    const handler = (): void => (player.ui.uiEvents$ as BehaviorSubject<IUiEventsStreamPayload>)
        .next({
            type: UiEventType.FRAME_BLUR
        });

    const {root} = player.refs;

    root.addEventListener('blur', handler);

    const release = () => root.removeEventListener('blur', handler);

    return {
        release
    };
};

export default bindRootBlurEvent;